const Style = {
  Card: 1,
  Embedded: 2,
  Collapsible: 3
};

export default Style;
